import { Controller as BaseController } from '@stimulus/core/dist/controller'

export class Controller extends BaseController {
  static targets = ['header', 'content', 'tabContent', 'nonCollapsibleHeader', 'loadingIndicator']

  connect() {
    this.updateContentHeight(true)
  }

  updateContentHeight(updateNow = false) {
    if (updateNow === true) {
      this.setContentHeight()
    } else {
      setTimeout(() => this.setContentHeight(), 250)
    }
  }

  setContentHeight() {
    this.contentTarget.style.height = this.calculateContentHeight()
  }

  calculateContentHeight() {
    if (this.hasNonCollapsibleHeaderTarget) {
      return `${window.innerHeight - this.nonCollapsibleHeaderTarget.getBoundingClientRect().height}px`
    }

    if (!this.hasHeaderTarget) {
      return `${window.innerHeight}px`
    }

    return '100%'
  }

  openInFlyout(event) {
    event.preventDefault()
    event = event.currentTarget

    const url = event.getAttribute('data-url')
    const urlPath = url.split('?')[0]

    if (url && url !== this.tabContentTarget.dataset.url) {
      // Clear out the current Flyout content, and show the loading indicator (again)
      this.reset()

      const loadedSection = this.tabContentTarget.querySelector(`[data-url="${urlPath}"]`)

      if (loadedSection) {
        loadedSection.hidden = false
        this.tabContentTarget.setAttribute('aria-busy', 'false')
        this.loadingIndicatorTarget.setAttribute('hidden', '')
        return
      }
      // Let assistive technologies know that the area is loading
      this.tabContentTarget.setAttribute('aria-busy', 'true')
      //
      this.load(url)
        .then(() => {
          // Let assistive technologies know that the area is no longer loading
          this.tabContentTarget.setAttribute('aria-busy', 'false')
          this.loadingIndicatorTarget.setAttribute('hidden', '')
          this.tabContentTarget.firstElementChild.setAttribute('data-url', urlPath)
        })

      // Capture the current Entity ID in a data attribute on the Flyout itself
    }
  }

  reset() {
    this.tabContentTarget.childNodes.forEach(el => el.hidden = true)
    this.loadingIndicatorTarget.hidden = false
  }

  load(url, requestOptions = {}) {
    return fetch(url, requestOptions)
      .then(response => response.text())
      .then((html) => {
        this.tabContentTarget.insertAdjacentHTML('afterbegin', html)
      })
      .catch(() => {
        this.tabContentTarget.insertAdjacentHTML('afterbegin', "<h2 class='flyout__error'>Failure loading Entity</h2>")
      })
  }
}
